const qaIps = ['192.168.68.141', '192.168.68.147', '192.168.68.148'];
export const environment = {
  allowHttpImages: true,
  production: true,
  API_URL: qaIps.includes(window.location.hostname) ? `http://${window.location.hostname}:8442`  : 'https://tolis.backend.ftstecnologia.homelinux.com',
  SOCKET_URL: qaIps.includes(window.location.hostname) ? `http://${window.location.hostname}:3006` : 'https://tolis.core.ftstecnologia.homelinux.com',
  NOTIFICACIONES_PUSH_SOCKET_URL: qaIps.includes(window.location.hostname) ? `http://${window.location.hostname}:3235/notificaciones-push` : 'https://tolis.notifications.ftstecnologia.homelinux.com/notificaciones-push',
  siteKey: "6Lc3-vYqAAAAAHj1kOGZoBViXy1sB5jHYAcuX_Ea",
  idleTimeoutSeconds: 900, // 15 minutos
  timeoutWarningSeconds: 15,
};
